import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import {
  MultiSelectField,
  MultiUserField,
} from 'module/types/filter-field/field/filterable-field';
import { MultiSelectFieldFilter } from 'module/types/filter-field/filter/multi-select';
import { MultiUserFieldFilter } from 'module/types/filter-field/filter/multi-user';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { FC } from 'react';
import { MultiSelectBaseCriteria } from './multi-select-base';
import { TagEditorComponents } from '../../field-editors/default-editor-components';
import { EditorComponents } from '../../field-editors/types';

interface Props {
  filter: MultiSelectFieldFilter;
  components?: EditorComponents;
  onChange: (filter: MultiSelectFieldFilter) => void;
  getFilterOperationTypeOptions?: (
    field: MultiUserField | MultiSelectField,
  ) => MultiUserFieldFilter[] | MultiSelectFieldFilter[];
  getOperationOptionRenderer?: (
    type: SelectFilterOperationType,
  ) => null | React.JSX.Element;
}

export const MultiSelectCriteria: FC<React.PropsWithChildren<Props>> = ({
  filter,
  onChange,
  components,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
}) => (
  <MultiSelectBaseCriteria
    components={{
      ...TagEditorComponents,
      ...components,
    }}
    filter={filter}
    onChange={onChange as any}
    options={optionsTransformer(filter.field).options.activeOptions}
    getFilterOperationTypeOptions={getFilterOperationTypeOptions}
    getOperationOptionRenderer={getOperationOptionRenderer}
  />
);
